import ComponentName from '@Constant/componentName'
import { FINANCE_MARK } from '@Constant/behaviorTrack'

const home = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/finance',
    redirect: {
      name: ComponentName.finance
    },
    children: [
      {
        component: () => import('../../views/finance/index.vue'),
        path: 'index',
        name: ComponentName.finance,
        auth: '*',
        meta: {
          title: '财务管理',
          logAuto: {
            pv: true,
            duration: true,
            source: FINANCE_MARK.PV
          }
        }
      }
    ]
  }
]

export default home
